import { render, staticRenderFns } from "./house-item.vue?vue&type=template&id=3df7c1b4&scoped=true&"
import script from "./house-item.vue?vue&type=script&lang=js&"
export * from "./house-item.vue?vue&type=script&lang=js&"
import style0 from "./house-item.vue?vue&type=style&index=0&id=3df7c1b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df7c1b4",
  null
  
)

export default component.exports